import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';

export class GetCarrierCreditCardCommand extends IRequestCommand<
IGetCarrierCreditCardResponse,
  ErrorDetails,
  IGetCarrierCreditCardCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'cards/{carrierUserId}/cardTypes';
  public override setParameters(parameters: IGetCarrierCreditCardCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
  }
}

export interface IGetCarrierCreditCardCommandParameters
  extends ICommandParameters {
  carrierUserId: string;
}

export interface IGetCarrierCreditCardResponse extends ICommandResponse {}
